<app-nested-table-form-field
  [editMode]="editMode"
  [fieldConfig]="fieldConfig"
  [data]="data"
  (valueChanged)="onValueChanged($event)"
  [formGroup]="formGroup"
  [fields]="fields"></app-nested-table-form-field>
